import React from "react";

const TabGPT = ({ activeTab, tabs, setActiveTab }) => {
  return (
    <div className="w-full border-b border-gray-200">
      <div className="flex flex-row min-h-fit overflow-x-auto scrollbar-hide">
        {tabs
          .filter((tab) => tab)
          .map((tab, index) => (
            <div
              key={index}
              className="flex min-h-fit flex-row gap-4 flex-shrink-0"
            >
              <button
                id={tab.id}
                className={`px-0 py-2 text-sm font-medium border-b-2 whitespace-nowrap transition-colors duration-200 ${
                  activeTab === tab.id
                    ? "border-indigo-500 text-indigo-500"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
              <div className="border-b-2 w-4 border-transparent"></div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default TabGPT;
